import { jsx as _jsx } from "react/jsx-runtime";
import { Input as MuiInput, } from '@mui/material';
import { forwardRef } from 'react';
import { styled } from '../../utils';
export const Input = forwardRef(function Input(props, ref) {
    const { hasValue, ...otherProps } = props;
    return (_jsx(InputStyled, { active: Boolean(hasValue && !props.disabled), ref: ref, ...otherProps }));
});
const InputStyled = styled(MuiInput, {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
    '&.Mui-disabled': {
        '&:before': {
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.white.dark,
        },
        color: theme.palette.white.dark,
        '& .MuiIcon-root': {
            color: theme.palette.white.dark,
        },
    },
    '&.Mui-error': {
        color: theme.palette.error.main,
        '&:after': {
            borderBottomColor: theme.palette.error.main,
        },
        '&:before': {
            borderBottomColor: theme.palette.error.main,
        },
        '& .MuiIcon-root': {
            color: theme.palette.error.main,
        },
    },
    '&.Mui-focused .MuiIcon-root': {
        color: theme.palette.primary.main,
    },
    '&.MuiInput-underline': {
        '&:not(.Mui-disabled):not(.Mui-error)': {
            '&:before': {
                borderBottomColor: active
                    ? theme.palette.primary.light
                    : theme.palette.primary.dark,
            },
            '&:after': {
                borderBottomColor: theme.palette.primary.light,
                borderBottomWidth: '1px',
            },
            '&:hover': {
                '&:before': {
                    borderBottomStyle: 'solid',
                    borderBottomColor: theme.palette.primary.lighter,
                },
                '&:after': {
                    borderBottomWidth: '2px',
                    borderBottomColor: theme.palette.primary.lighter,
                },
                '& .MuiIcon-root': {
                    color: theme.palette.primary.lighter,
                },
            },
        },
    },
}));
